import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
import { CustomDialogTitle } from "../../ui";

export const ResetPasswordDialog = ({ open, onClose, onSubmit }) => (
  <Dialog
    open={open}
    onClose={onClose}
    fullWidth
    component="form"
    noValidate
    onSubmit={(event) => {
      event.preventDefault();
      event.stopPropagation();
      onSubmit();
      onClose();
    }}
  >
    <CustomDialogTitle title="Konfirmasi" onClose={onClose} />
    <DialogContent>
      <Typography>
        Apakah Anda yakin untuk melakukan Reset Password pada user terkait?
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="error" type="submit">
        Ya, Reset Password
      </Button>
    </DialogActions>
  </Dialog>
);

ResetPasswordDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};
